module.exports = __webpack_public_path__ + "static/media/FoamMock.85a7b102.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/zerowaste/FoamMock.jpg
// module id = 206
// module chunks = 0